import {
  getListCompetitionGroups,
  getListCompetitionMatches,
  getListCompetitionParticipants,
  getListCompetitionStages,
  getListGroupStandings,
} from "../api";
import {
  CompetitionGroup,
  CompetitionStage,
  GroupStanding,
  ID,
  Match,
  TournamentParticipant,
} from "../types";

export interface CompetitionBundle {
  participants: TournamentParticipant[];
  stages: CompetitionStage[];
  groups: CompetitionGroup[];
  matches: Match[];
  standings: GroupStanding[];
}

export const loadCompetitionBundle = async (eventId: ID): Promise<CompetitionBundle> => {
  const [participants, stages, groups, matches, standings] = await Promise.all([
    getListCompetitionParticipants(eventId),
    getListCompetitionStages(eventId),
    getListCompetitionGroups({ eventId }),
    getListCompetitionMatches({ eventId }),
    getListGroupStandings({ eventId }),
  ]);

  return {
    participants,
    stages,
    groups,
    matches,
    standings,
  };
};
